<!-- Documentação necessária -->
<div class="timeline-badge">
  <a><em class="fa fa-circle"></em></a>
</div>

<h4 *ngIf="timelineActive">{{ timeline.dataHora | date:'HH:mm'}} <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small></h4>

<div class="timeline-panel" [ngClass]="{'timeline-panel-disabled': !timelineActive}">
  <div class="step">
    <span class="icon"></span>

    <h2>{{ timeline.tituloStatus }}</h2>

    <span>{{ timeline.subTituloStatus}}</span>

    <app-upload-arquivos
      *ngIf="timeline.cardDireito.length > 0"
      [documentos]="documents"
      [idFicha]="idFicha"
      [cliente]="cliente"
      [timeline]="fullTimeline"
      (pushDocumentacao)="onPushDocumentacao($event)"
    ></app-upload-arquivos>

    <div *ngIf="!timelineActive"><br /></div>
  </div>
</div>
